// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-9d9b1e94]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.align-right[data-v-9d9b1e94] {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
